import { Variants } from "framer-motion"

/**
 * Shared Framer Motion animation variants for consistent animations across the app
 */

// Fade in animation
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
}

// Slide up animation
export const slideUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

// Scale in animation
export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
}

// Stagger container for children
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
}

// Card hover effect - light mode
export const cardHoverLight = {
  scale: 1.02,
  y: -4,
  transition: {
    duration: 0.2,
    ease: [0.22, 1, 0.36, 1] as const,
  },
}

// Card hover effect - dark mode (softer, with brightness)
export const cardHoverDark = {
  scale: 1.01,
  y: -2,
  filter: "brightness(1.05)",
  transition: {
    duration: 0.2,
    ease: [0.22, 1, 0.36, 1] as const,
  },
}

// Card entrance animation
export const cardEntrance: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

// Stat value number animation
export const statValue: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: "easeOut",
    },
  },
}

// Get card hover effect based on theme
export const getCardHoverEffect = (isDark: boolean) => {
  return isDark ? cardHoverDark : cardHoverLight
}
